import React, { useState } from 'react';
import { Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import {
  canCopyProcess,
  buildCopyPayload,
  APPROVAL_CENTER_COPY_PATH,
  isOnboardingProcess,
  resolveOnboardingEmployeeNo,
  parseProcessFormData
} from './copyProcessUtils';

export { canCopyProcess } from './copyProcessUtils';

export default function ProcessCopyAction({
  process,
  bizType = 'hr_process',
  onBeforeNavigate
}) {
  const navigate = useNavigate();
  const [copying, setCopying] = useState(false);

  const handleCopy = async () => {
    if (isOnboardingProcess(process)) {
      const employeeNo = resolveOnboardingEmployeeNo(process);
      onBeforeNavigate?.();
      if (employeeNo) {
        navigate(`/hr/onboarding/${employeeNo}/edit`);
        message.success('已打开入职表单，请修改后从入职管理提交审批');
        return;
      }
      try {
        setCopying(true);
        const formData = parseProcessFormData(process);
        const res = await api.post('/hr/onboarding/drafts', { form_json: formData });
        if (res.data.success) {
          navigate(`/hr/onboarding/drafts/${res.data.data.id}`);
          message.success('已复制为入职草稿，请确认后提交');
        }
      } catch (e) {
        message.error(e.response?.data?.message || '复制入职表单失败');
      } finally {
        setCopying(false);
      }
      return;
    }

    const copyPayload = buildCopyPayload(process, bizType);
    if (!copyPayload) {
      message.error('无法复制该流程类型');
      return;
    }

    onBeforeNavigate?.();
    navigate(APPROVAL_CENTER_COPY_PATH, { state: { copyProcess: copyPayload } });
    message.success('已复制表单，请确认后提交');
  };

  return (
    <div className="process-detail-actions">
      <Button type="primary" loading={copying} onClick={handleCopy}>
        复制流程
      </Button>
    </div>
  );
}
